import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
// MUI ICON COMPONENT
import LoginIcon from '@mui/icons-material/Login';
import PersonOutline from "@mui/icons-material/PersonOutline";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import VerifiedIcon from '@mui/icons-material/Verified';
import EmailIcon from '@mui/icons-material/Email';
// CUSTOM ICON COMPONENT

import ShoppingBagOutlined from "@/icons/ShoppingBagOutlined";
// GLOBAL CUSTOM HOOK


import useCart from "@/hooks/useCart";
import {H5, H6, Paragraph} from "@/components/Typography.jsx";
import {useEffect, useState} from "react";
import {ListItemIcon, Popover, Tooltip, Box, Chip} from "@mui/material";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import Divider from "@mui/material/Divider";
import {Logout, PersonAdd} from "@mui/icons-material";
import Settings from "@mui/icons-material/Settings";
import Menu from "@mui/material/Menu";
import {Link, router} from "@inertiajs/react";
import NotificationsPopover from "@/components/layouts/vendor-dashboard/dashboard-navbar/notification-popover.jsx";
import {FlexBox} from "@/components/flex-box/index.js";
// ==============================================================


// ==============================================================
export default function LoginCartButtons({
                                             toggleDialog,
                                             toggleSidenav,
                                             auth,
                                         }) {
    const {
        state
    } = useCart();
    const ICON_COLOR = {
        color: "grey.600",
    };
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return <div>

        <FlexBox gap={1} alignItems="center">
            {
                auth?.user &&
                <NotificationsPopover />
            }

            {
                auth?.user ?
                    <Box sx={{ position: 'relative' }}>
                        <IconButton onClick={handleClick}>
                            <Badge
                                invisible={!!auth.user.email_verified_at}
                                badgeContent={
                                    <WarningAmberIcon sx={{ width: 12, height: 12 }} />
                                }
                                color="warning"
                                overlap="circular"
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                            >
                                <PersonOutline sx={ICON_COLOR}/>
                            </Badge>
                        </IconButton>
                    </Box>
                    :
                    <IconButton onClick={toggleDialog}>
                        <H5 sx={{p:1}}>Login</H5>
                    </IconButton>

            }

            <Badge badgeContent={state.cart.length} color="primary">
                <IconButton onClick={toggleSidenav}>
                    <ShoppingBagOutlined sx={ICON_COLOR}/>
                </IconButton>
            </Badge>
        </FlexBox>
        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{horizontal: 'right', vertical: 'top'}}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
        >
            {/* Show user info and verification status */}
            {auth?.user && (
                <Box sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
                    <Typography variant="subtitle2" noWrap>
                        {auth.user.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" noWrap>
                        {auth.user.email}
                    </Typography>
                    {!auth.user.email_verified_at && (
                        <Chip
                            label="Email not verified"
                            size="small"
                            color="warning"
                            icon={<WarningAmberIcon />}
                            sx={{ mt: 0.5 }}
                        />
                    )}
                </Box>
            )}

            {/* Show verify email option if not verified */}
            {auth?.user && !auth.user.email_verified_at && (
                <>
                    <MenuItem onClick={() => {
                        handleClose();
                        router.get(route('verification.notice'));
                    }}>
                        <ListItemIcon>
                            <EmailIcon fontSize="small" color="warning" />
                        </ListItemIcon>
                        <H6 color="warning.main">Verify Email</H6>
                    </MenuItem>
                    <Divider/>
                </>
            )}

            <MenuItem onClick={handleClose}>
                <Link href='/user/profile' style={{display: 'flex'}}>
                    <ListItemIcon>
                        <AccountCircleIcon fontSize="small"/>
                    </ListItemIcon>
                    <H6>My Profile</H6>
                </Link>
            </MenuItem>
            <MenuItem onClick={handleClose}>
                <Link href='/user/orders' style={{display: 'flex'}}>
                    <ListItemIcon>
                        <ShoppingBagOutlinedIcon fontSize="small"/>
                    </ListItemIcon>
                    <H6>My Orders</H6>
                </Link>
            </MenuItem>
            <Divider/>
            <MenuItem onClick={() => {
                setAnchorEl(null);
                router.post(route('logout'), {}, {
                    onSuccess: () => {
                        localStorage.removeItem("cart");
                        window.location.replace('/');
                    },
                    onError: (errors) => {
                        console.error('Logout failed:', errors);
                    }
                });
            }}>
                <ListItemIcon>
                    <Logout fontSize="small"/>
                </ListItemIcon>
                Logout
            </MenuItem>
        </Menu>
    </div>;
}
